import AppInstall from './AppInstall';
import './style/index.less';

export default AppInstall;
